type IDesignationState = {
    designation_id: number;
    designation: string;
}

export enum IDesignationActionTypes {
    FETCH_DESIGNATION_LIST_REQUEST = 'FETCH_DESIGNATION_LIST_REQUEST',
    FETCH_DESIGNATION_LIST_SUCCESS = 'FETCH_DESIGNATION_LIST_SUCCESS',
    FETCH_DESIGNATION_LIST_FAILURE = 'FETCH_DESIGNATION_LIST_FAILURE',
}

export type IDesignationActionCreator = {
    type: string;
    payload: IDesignationState;
  };

export default IDesignationState